import AjaxErrorBoundary from './AjaxErrorBoundary';

export * from './types';

export default AjaxErrorBoundary;
